import { useTranslation } from 'react-i18next';
import { Text } from '@client/toolkit';

export interface BuildingStatisticsHeaderProps {
  showAreaColumns?: boolean;
}

export function BuildingStatisticsHeader({ showAreaColumns = true }: BuildingStatisticsHeaderProps) {
  const { t, ready } = useTranslation('rentalObjects');
  const { t: tGlobal } = useTranslation('global');
  const { t: tType } = useTranslation('type');

  return (
    <div className="border-t border-border" style={{ backgroundColor: '#332F2C' }}>
      <div className="flex items-center px-2 py-2">
        <div className="px-3 py-1 flex-1 min-w-0 overflow-hidden">
          <Text
            as="div"
            className="font-medium text-white text-xs whitespace-nowrap"
            loading={!ready}
          >
            {tGlobal('entity.building')}
          </Text>
        </div>
        <div className="shrink-0 flex items-center">
          <div className="flex items-center gap-4">
            {showAreaColumns && (
            <>
              <div className="px-3 py-1 text-left w-[160px]">
                <Text
                  as="div"
                  className="font-medium text-white text-xs whitespace-nowrap"
                  loading={!ready}
                >
                  {tGlobal('entity.tag', { count: 0 })}
                </Text>
              </div>
              <div className="px-3 py-1 text-left w-[90px]">
                <Text
                  as="div"
                  className="font-medium text-white text-xs whitespace-nowrap"
                  loading={!ready}
                >
                  {t('totalArea')}
                </Text>
              </div>
              <div className="px-3 py-1 text-left w-[155px]">
                <Text
                  as="div"
                  className="font-medium text-white text-xs whitespace-nowrap"
                  loading={!ready}
                >
                  {t('rentedArea')}
                </Text>
              </div>
              <div className="px-3 py-1 text-left w-[90px]">
                <Text
                  as="div"
                  className="font-medium text-white text-xs whitespace-nowrap"
                  loading={!ready}
                >
                  {t('vacantArea')}
                </Text>
              </div>
              <div className="px-3 py-1 text-left w-[90px]">
                <Text
                  as="div"
                  className="font-medium text-white text-xs whitespace-nowrap"
                  loading={!ready}
                >
                  {tType('SpaceDiscriminator.CommonArea')}
                </Text>
              </div>
            </>
          )}
          <div className="px-3 py-1 text-left min-w-[80px]">
            <Text
              as="div"
              className="font-medium text-white text-xs whitespace-nowrap"
              loading={!ready}
            >
              {tType('VacancyStatus.Rented')}
            </Text>
          </div>
          <div className="px-3 py-1 text-left min-w-[80px]">
            <Text
              as="div"
              className="font-medium text-white text-xs whitespace-nowrap"
              loading={!ready}
            >
              {tType('VacancyStatus.Vacant')}
            </Text>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}
